var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeOpenText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2267 9.07425C2.08189 9.35106 2 9.66597 2 10V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V10C22 9.66597 21.9181 9.35106 21.7733 9.07426L13.577 14.8116C12.6301 15.4745 11.3699 15.4745 10.423 14.8116L2.2267 9.07425Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V8.48457L11.2832 13.5828C11.7136 13.8841 12.2864 13.8841 12.7168 13.5828L20 8.48458V4ZM6.25 5C6.25 4.58579 6.58579 4.25 7 4.25H13C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41421 13.4142 5.75 13 5.75H7C6.58579 5.75 6.25 5.41421 6.25 5ZM7 7.25H16C16.4142 7.25 16.75 7.58579 16.75 8C16.75 8.41421 16.4142 8.75 16 8.75H7C6.58579 8.75 6.25 8.41421 6.25 8C6.25 7.58579 6.58579 7.25 7 7.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpenText);
export default __webpack_public_path__ + "static/media/envelope-open-text.35cffbd835021285af007863542e2bec.svg";
export { ForwardRef as ReactComponent };